"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformProvider = exports.PlatformConsumer = exports.PlatformContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const hooks_1 = require("../hooks");
const getDeviceInformation_1 = require("../selectors/getDeviceInformation");
exports.PlatformContext = (0, react_1.createContext)({});
const PlatformConsumer = (props) => {
    return ((0, jsx_runtime_1.jsx)(exports.PlatformContext.Consumer, { children: (value) => (0, react_1.cloneElement)(props.children, { platform: value }) }));
};
exports.PlatformConsumer = PlatformConsumer;
const defaultState = {
    isMobile: false,
    isDesktop: true,
    isApple: true,
    isAndroid: false,
    isWindows: false,
    isSurfaceHub: false,
    isIOS: false,
    isTablet: false,
    platform: bridge_schema_1.Platform.Mac,
};
/**
 * Platform information provider
 */
function PlatformProvider({ children }) {
    var _a;
    const [state, setState] = (0, react_1.useState)(defaultState);
    const { kind: deviceKind, platform } = (_a = (0, hooks_1.useSelector)(getDeviceInformation_1.getDeviceInformation)) !== null && _a !== void 0 ? _a : {};
    (0, react_1.useEffect)(() => {
        updateState();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [platform]);
    const updateState = () => {
        const newState = platform !== undefined && deviceKind !== undefined
            ? {
                isMobile: deviceKind === bridge_schema_1.DeviceKind.Phone,
                isDesktop: deviceKind === bridge_schema_1.DeviceKind.Desktop,
                isApple: (platform & bridge_schema_1.Platform.Apple) !== 0,
                isAndroid: (platform & bridge_schema_1.Platform.Google) !== 0,
                isWindows: (platform & bridge_schema_1.Platform.Microsoft) !== 0,
                isSurfaceHub: (platform & bridge_schema_1.Platform.SurfaceHub) !== 0,
                isIOS: (platform & bridge_schema_1.Platform.iOS) !== 0,
                isTablet: deviceKind === bridge_schema_1.DeviceKind.Tablet,
                platform: platform,
            }
            : {
                isMobile: false,
                isDesktop: false,
                isApple: false,
                isAndroid: false,
                isWindows: false,
                isSurfaceHub: false,
                isIOS: false,
                isTablet: false,
                platform: undefined,
            };
        setState(newState);
    };
    if (!children) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(exports.PlatformContext.Provider, { value: state, children: children }));
}
exports.PlatformProvider = PlatformProvider;
